import React, { useEffect } from "react";

// Default UTM tags for each vanity target. Any UTM already in the incoming URL
// overrides the default so partner links can carry their own attribution.
const TARGETS = {
  kindness: {
    path: "kindness",
    defaults: {
      utm_source: "social",
      utm_medium: "video",
      utm_campaign: "scl_enrollment",
      utm_content: "kindness",
    },
  },
  activity: {
    path: "spinner",
    defaults: {
      utm_source: "social",
      utm_medium: "video",
      utm_campaign: "scl_enrollment",
      utm_content: "activity",
    },
  },
};

export default function VanityRedirect({ target }) {
  useEffect(() => {
    const cfg = TARGETS[target];
    if (!cfg) {
      window.location.replace("/");
      return;
    }
    const incoming = new URLSearchParams(window.location.search);
    const params = new URLSearchParams();
    params.set("path", cfg.path);
    // Start with defaults, then let any incoming UTM (or lang) override.
    for (const [k, v] of Object.entries(cfg.defaults)) params.set(k, v);
    for (const [k, v] of incoming.entries()) {
      if (k === "path") continue; // never override the vanity's target path
      if (v) params.set(k, v);
    }
    window.location.replace(`/?${params.toString()}`);
  }, [target]);

  return (
    <div className="min-h-screen bg-scl-cream flex items-center justify-center" data-testid={`vanity-redirect-${target}`}>
      <div className="text-scl-charcoal/70 text-sm">Loading…</div>
    </div>
  );
}
